// Generated from the product translation catalog; keep keys aligned across locales.
export const en = {
  'layout.account': 'My account',
  'layout.accountPreferences': 'Account and preferences',
  'layout.myProfile': 'My profile',
  'layout.signOut': 'Sign out',
  'layout.language': 'Language',
  'layout.appearance': 'Theme',
  'layout.menu': 'Menu',
  'layout.openMenu': 'Open main menu',
  'layout.back': 'Back',
  'layout.closeMenu': 'Close menu',
  'layout.pageActions': 'Page actions',
  'layout.mainNavigation': 'Main navigation',
  'layout.supportNavigation': 'Help navigation',
  'layout.dailyWork': 'DAILY WORK',
  'layout.administration': 'ADMINISTRATION',
  'layout.reporting': 'REPORTING',
  'layout.yourBusiness': 'YOUR BUSINESS',
  'layout.businessAccount': 'Business account',
  'layout.allCompanies': 'All companies',
  'layout.workspace': 'Workspace',
  'layout.tagline': 'Your business records, close at hand.',
  'layout.faq': 'Frequently asked questions',
  'layout.skipContent': 'Skip to content',
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.reports': 'Reports',
  'nav.companies': 'Companies',
  'nav.users': 'Users',
  'nav.customers': 'Customers',
  'nav.items': 'Items',
  'nav.sales': 'Sales',
  'nav.sale-history': 'Sale History',
  'nav.debts': 'Customer Accounts',
  'nav.expenses': 'Expense Ledger',
  'nav.profile': 'Profile',
  'nav.help': 'Help',
  'nav.faq': 'FAQ',
  'nav.logout': 'Logout',
  
  // Auth
  'auth.login': 'Login',
  'auth.accessDeniedTitle': 'This page is unavailable',
  'auth.accessDeniedDescription': 'Your account does not have permission to view this page.',
  'auth.accessDeniedHelp': 'Check that you are signed in with the right account, or open the help page.',
  'auth.signInDescription': 'Access your business records securely.',
  'auth.showPassword': 'Show password',
  'auth.hidePassword': 'Hide password',
  'auth.registrationDescription': 'Create your business account in a few steps.',
  'auth.registrationNextStep': 'After registration, verify your account with the code sent to your email.',
  'auth.registrationEmailHint': 'Required to verify your account.',
  'auth.phoneNumberMinLength': 'Phone number must be at least 10 characters.',
  'auth.email': 'Email',
  'auth.password': 'Password',
  'auth.loginButton': 'Sign In',
  'auth.forgotPassword': 'Forgot password?',
  'auth.forgotPasswordDescription': 'Enter your email address and we will send you a password reset link.',
  'auth.sendPasswordResetLink': 'Send reset link',
  'auth.passwordResetRequestAccepted': 'If an account exists for this email, a password reset link has been sent.',
  'auth.passwordResetRequestFailed': 'Unable to request a password reset. Please try again.',
  'auth.resetPassword': 'Reset password',
  'auth.resetPasswordDescription': 'Choose a new password for your account.',
  'auth.newPassword': 'New password',
  'auth.resetPasswordButton': 'Set new password',
  'auth.invalidPasswordResetLink': 'This password reset link is invalid or incomplete.',
  'auth.passwordResetSuccess': 'Password reset successfully. You can now log in.',
  'auth.passwordResetFailed': 'Password reset failed. The link may be invalid or expired.',
  'auth.register': 'Register',
  'auth.firstName': 'First Name',
  'auth.lastName': 'Last Name',
  'auth.username': 'Username',
  'auth.phoneNumber': 'Phone Number',
  'auth.registerButton': 'Register',
  'auth.alreadyHaveAccount': 'Already have an account?',
  'auth.dontHaveAccount': "Don't have an account?",
  'auth.createAccount': 'Create Account',
  'auth.personalInfo': 'Personal Information',
  'auth.accountDetails': 'Account Details',
  'auth.companyInfo': 'Company Information',
  'auth.referralCode': 'Referral code',
  'auth.referralCodeHint': 'Enter the code of the person who invited you.',
  'auth.verification': 'Verification',
  'auth.next': 'Next',
  'auth.back': 'Back',
  'auth.finish': 'Finish',
  'auth.step': 'Step',
  'auth.of': 'of',
  'auth.orContinueWith': 'Or continue with',
  'auth.continueWithGoogle': 'Continue with Google',
  'auth.continueWithFacebook': 'Continue with Facebook',
  'auth.comingSoon': 'Coming Soon',
  'auth.googleLoginComingSoon': 'Google login will be implemented soon',
  'auth.facebookLoginComingSoon': 'Facebook login will be implemented soon',
  'auth.emailVerification': 'Email Verification',
  'auth.verifyEmail': 'Verify Email',
  'auth.verificationSent': 'Verification email sent!',
  'auth.checkEmail': 'Please check your email for verification link',
  'auth.resendVerification': 'Resend Verification Email',
  'auth.emailVerified': 'Email Verified!',
  'auth.emailVerifiedMessage': 'Your email has been verified successfully. You can now log in.',
  'auth.verificationFailed': 'Verification Failed',
  'auth.invalidToken': 'Invalid or expired verification token',
  'auth.emailNotVerified': 'Please verify your email before logging in. Check your inbox for the verification link.',
  'auth.invalidCredentials': 'Invalid username/email or password. Please try again.',
  'auth.userNotFound': 'User not found. Please check your username or email address.',
  'auth.serverConnectionError': 'Cannot connect to server. Please ensure the backend is running.',
  'auth.loginFailed': 'Login failed. Please try again.',
  'auth.fieldRequired': 'This field is required',
  'auth.usernameOrEmailHelper': 'Enter your username or email address',
  'auth.confirmPassword': 'Confirm Password',
  'auth.passwordMismatch': 'Passwords do not match',
  'auth.emailInvalid': 'Please enter a valid email address',
  'auth.passwordMinLength': 'Password must be at least 6 characters',
  'auth.usernameMinLength': 'Username must be at least 3 characters',
  'auth.verifyingEmail': 'Verifying your email...',
  'auth.redirectingToLogin': 'Redirecting to login page...',
  'auth.enterEmailAndCode': 'Enter your email and the 6-digit verification code sent to your inbox',
  'auth.verificationCodeLength': 'Verification code must be 6 characters',
  'auth.verificationCodeHelper': 'Enter the 6-character code from your email',
  'auth.verificationCodeLabel': 'Verification Code (6 characters)',
  'auth.verifyEmailButton': 'Verify Email',
  'auth.resendVerificationCode': 'Resend Verification Code',
  'auth.backToLogin': 'Back to Login',
  'auth.tryAgainWithCode': 'Try Again with Code',
  'auth.goToLogin': 'Go to Login',
  'auth.or': 'OR',
  'auth.backToHome': 'Back to Home',
  'auth.verifyYourEmail': 'Verify Your Email',
  'auth.emailAddress': 'Email Address',
  'auth.registrationFailed': 'Registration failed. Please try again.',
  'auth.verificationResent': 'Verification email sent! Please check your inbox.',
  'auth.verificationResendFailed': 'Failed to resend verification email',
  'auth.verificationThrottled': 'Please wait before requesting another verification email.',
  'auth.verificationRetryAfter': 'You can try again in {{seconds}} seconds.',
  'auth.verificationCodeFailed': 'Verification failed. Please check your code and try again.',
  'auth.enterEmailAddress': 'Please enter your email address',
  'auth.enterEmailAndCodeError': 'Please enter both email and verification code',
  'auth.emailVerificationSuccessShort': 'Email verified! You can now log in.',
  'auth.phoneNumberRequired': 'Phone number is required',
  'auth.phoneNumberInvalid': 'Please enter a valid phone number',
  'auth.companyName': 'Company Name',
  'auth.companyAddress': 'Company Address',
  'auth.companyPhone': 'Company Phone',
  'auth.companyEmail': 'Company Email',
  'auth.companyWebsite': 'Company Website',
  
  // Common
  'common.add': 'Add',
  'common.edit': 'Edit',
  'common.delete': 'Delete',
  'common.save': 'Save',
  'common.ok': 'OK',
  'common.processing': 'Processing...',
  'common.saving': 'Saving...',
  'common.columns': 'Columns',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.create': 'Create',
  'common.update': 'Update',
  'common.search': 'Search',
  'common.clearSearch': 'Clear search',
  'common.filters': 'Filters',
  'common.view': 'View',
  'common.all': 'All',
  'common.clearFilters': 'Clear Filters',
  'common.actions': 'Actions',
  'common.name': 'Name',
  'common.email': 'Email',
  'common.phone': 'Phone',
  'common.address': 'Address',
  'common.price': 'Price',
  'common.loading': 'Loading...',
  'common.error': 'Error',
  'common.success': 'Success',
  'common.confirm': 'Confirm',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.page': 'Page',
  'common.of': 'of',
  'common.showing': 'Showing',
  'common.rowsPerPage': 'Rows per page',
  'common.areYouSure': 'Are you sure?',
  'common.thisActionCannotBeUndone': 'This action cannot be undone.',
  'common.comingSoon': 'Coming Soon',
  'common.optional': 'Optional',
  'common.created': 'Created',
  'common.createdAt': 'Created At',
  'common.retry': 'Retry',
  'common.rateLimit': 'Too many requests. Please try again shortly.',
  'common.rateLimitWithRetry': 'Too many requests. Please try again in {seconds} seconds.',
  'common.found': 'Found',
  'common.matching': 'matching',
  'common.tryAdjusting': 'Try adjusting your search terms',
  'common.getStarted': 'Get started by adding your first',
  'common.system': 'System',
  'common.noFound': 'No {0} found',
  'common.noYet': 'No {0} yet',
  'common.addFirst': 'Add First {0}',
  'common.searchBy': 'Search {0} by {1}...',
  'common.management': '{0} Management',
  'subscription.readOnlyBanner': 'Your subscription has expired or is read-only. Creating and changing records is unavailable.',
  'common.removing': 'Removing...',
  'common.adjusting': 'Adjusting...',
  'common.adding': 'Adding...',
  
  // Companies
  'companies.title': 'Companies',
  'companies.subtitle': 'Manage business accounts and subscriptions.',
  'companies.formHint': 'Add the company’s basic contact details.',
  'companies.clearSearch': 'Clear search',
  'companies.nameRequired': 'Company name is required.',
  'companies.emailInvalid': 'Enter a valid email address.',
  'companies.phoneInvalid': 'Enter a valid phone number.',
  'companies.websiteInvalid': 'Website must start with http:// or https://.',
  'companies.saveError': 'Could not save company.',
  'companies.loadError': 'Could not load companies.',
  'companies.createSuccess': 'Company created.',
  'companies.updateSuccess': 'Company updated.',
  'companies.addCompany': 'Add Company',
  'companies.source': 'Acquisition source',
  'companies.sourceReferral': 'Referral',
  'companies.sourceOrganic': 'Organic',
  'companies.sourceAdmin': 'Admin created',
  'companies.sourceLegacy': 'Legacy / unknown',
  'subscription.manage': 'Manage subscription',
  'subscription.manageTitle': 'Subscription management',
  'subscription.formHint': 'Set the plan status and validity dates.',
  'subscription.paidActivation': 'Confirm first paid activation and apply the referral reward',
  'subscription.invalidDateRange': 'End date cannot be before start date.',
  'subscription.planCode': 'Plan code',
  'subscription.status': 'Status',
  'subscription.active': 'Active',
  'subscription.readOnly': 'Read-only',
  'subscription.suspended': 'Suspended',
  'subscription.startsAt': 'Start date',
  'subscription.endsAt': 'End date',
  'subscription.endsAtHelper': 'Leave blank for an unlimited subscription.',
  'subscription.notes': 'Notes',
  'subscription.saved': 'Subscription updated',
  'subscription.loadFailed': 'Unable to load subscription',
  'subscription.saveFailed': 'Unable to update subscription',
  'companies.editCompany': 'Edit Company',
  'companies.deleteCompany': 'Delete Company',
  'companies.companyName': 'Company Name',
  'companies.website': 'Website',
  'companies.priceEntryMode': 'Catalog price entry',
  'companies.priceEntryModeVatExcluded': 'Prices exclude VAT',
  'companies.priceEntryModeVatIncluded': 'Prices include VAT',
  'companies.defaultVatRate': 'Default VAT rate',
  'companies.defaultVatRateHint': 'Applied to new items; it can still be changed per item.',
  'companies.defaultVatRateInvalid': 'Choose one of the supported VAT rates: 0%, 1%, 10%, or 20%.',
  'companies.batchTrackingEnabled': 'Enable batch tracking',
  'companies.batchTrackingHint': 'Use batch numbers and expiration dates across the company.',
  'companies.createCompany': 'Create New Company',
  'companies.deleteConfirm': 'Are you sure you want to delete this company?',
  'companies.searchByNameEmailPhone': 'Search companies by name, email, or phone...',
  'companies.searchPlaceholder': 'Search companies...',
  'companies.noFound': 'No companies found',
  'companies.noYet': 'No companies yet',
  'companies.getStarted': 'Get started by adding your first company',
  'companies.addFirstCompany': 'Add First Company',
  'companies.saving': 'Saving...',
  'companies.create': 'Create',
  'companies.detailLoadError': 'Could not load company details.',
  'companies.summaryLoadError': 'Could not load company summary.',
  'companies.subscriptionStatus': 'Effective subscription',
  'companies.subscriptionEnds': 'Ends / remaining',
  'companies.usageStatus': 'Usage status',
  'companies.allStatuses': 'All subscriptions',
  'companies.allUsageStatuses': 'All usage statuses',
  'companies.expiringFilter': 'Expiry filter',
  'companies.allExpiry': 'All expiry dates',
  'companies.expiring7': 'Expires within 7 days',
  'companies.expiring30': 'Expires within 30 days',
  'companies.usageActive': 'Used in the last 30 days',
  'companies.usageInactive': 'No use for 30 days',
  'companies.usageNever': 'No activity yet',
  'companies.days': 'days',
  'companies.unlimited': 'Unlimited',
  'companies.companyOperations': 'Company data',
  'companies.companyOperationsHint': 'Open this company’s customers and items with the company scope preserved.',
  'companies.openCustomers': 'Open customers',
  'companies.openItems': 'Open items',
  'companies.openSales': 'Open sales',
  'companies.openDebts': 'Open account movements',
  'companies.openExpenses': 'Open expenses',
  'companies.detailOverview': 'Overview',
  'companies.detailUsers': 'Users',
  'companies.detailSubscription': 'Subscription',
  'companies.detailNotes': 'Notes',
  'companies.createdAt': 'Created',
  'companies.usersCount': 'Users',
  'companies.customersCount': 'Customers',
  'companies.itemsCount': 'Items',
  'companies.periodSales': 'Period sales',
  'companies.periodCollections': 'Period collections',
  'companies.lastActivity': 'Last business activity',
  'companies.neverUsed': 'No activity yet',
  'companies.notesFromDetail': 'Internal company follow-up notes.',
  'companies.addNote': 'Add note',
  'common.back': 'Back',
  'companies.update': 'Update',
  'companies.deleting': 'Deleting...',
  'companies.deleteWarning': 'This action cannot be undone. All data associated with this company will be permanently deleted.',
  'companies.deleteQuestion': 'Are you sure you want to delete this company? This will also delete:',
  'companies.deleteSuccess': 'Company deleted successfully',
  'companies.deleteConsequences.allUsers': 'All users associated with this company',
  'companies.deleteConsequences.allCustomers': 'All customers associated with this company',
  'companies.deleteConsequences.allItems': 'All items/inventory associated with this company',
  'companies.deleteConsequences.allData': 'All related data and history',
  'companies.deleteError.generic': 'Failed to delete company',
  'companies.deleteError.hasUsers': 'Cannot delete company: This company has associated users. Please remove all users from this company first.',
  'companies.deleteError.hasData': 'Cannot delete company: This company has associated data. Please remove all associated data first.',
  
  // Users
  'users.title': 'Users',
  'users.subtitle': 'Manage team accounts and access roles.',
  'users.passwordRequired': 'Password is required',
  'users.companyRequired': 'Select a company for this role',
  'users.keepPassword': 'Leave blank to keep the current password',
  'users.loadingCompanies': 'Loading companies...',
  'users.createSuccess': 'User created',
  'users.updateSuccess': 'User updated',
  'users.deleteSuccess': 'User deleted',
  'users.saveError': 'Could not save user',
  'users.deleteError': 'Could not delete user',
  'users.management': 'User Management',
  'users.addUser': 'Add User',
  'users.editUser': 'Edit User',
  'users.deleteUser': 'Delete User',
  'users.createUser': 'Create New User',
  'users.username': 'Username',
  'users.role': 'Role',
  'users.company': 'Company',
  'users.created': 'Created At',
  'users.firstName': 'First Name',
  'users.lastName': 'Last Name',
  'users.name': 'Name',
  'users.password': 'Password',
  'users.confirmPassword': 'Confirm Password',
  'users.selectRole': 'Select Role',
  'users.selectCompany': 'Select Company',
  'users.noEmail': 'No email',
  'users.noUsers': 'No users found',
  'users.noSearchResults': 'No search results found',
  'users.noUsersYet': 'No users yet',
  'users.searchUsers': 'Search users by username or name...',
  'users.addFirstUser': 'Add First User',
  'users.addFirstEmployee': 'Add First Employee',
  'users.deleteConfirm': 'Are you sure you want to delete this user?',
  'users.addEmployee': 'Add Employee',
  'users.saving': 'Saving...',
  'users.create': 'Create',
  'users.update': 'Update',
  'users.emailVerificationSent': 'Verification email sent to the new address',
  'users.deleting': 'Deleting...',
  'users.deleteWarning': 'This action cannot be undone. The user will lose access to the system immediately.',
  'users.deleteQuestion': 'Are you sure you want to delete this user? This will:',
  'users.deleteConsequences.removeAccess': 'Remove the user\'s access to the system',
  'users.deleteConsequences.preserveData': 'Preserve historical data (transactions, etc.)',
  'users.deleteConsequences.cannotUndo': 'Cannot be undone without recreating the user',
  'users.deleteConsequences.companyAdminWarning': 'Warning: This will remove a Company Admin',
  
  // Customers
  'customers.title': 'Customers',
  'customers.directoryEyebrow': 'CUSTOMER DIRECTORY',
  'customers.directoryDescription': 'Keep contact details current and open customer accounts with ease.',
  'customers.previousPage': 'Previous page',
  'customers.nextPage': 'Next page',
  'customers.clearSearch': 'Clear search',
  'customers.addCustomer': 'Add Customer',
  'customers.editCustomer': 'Edit Customer',
  'customers.deleteCustomer': 'Delete Customer',
  'customers.bulkUpload': 'Bulk Upload',
  'customers.importCsv': 'Import CSV',
  'customers.deleteConfirm': 'Are you sure you want to delete this customer?',
  'customers.customerName': 'Customer Name',
  'customers.firstName': 'First Name',
  'customers.lastName': 'Last Name',
  'customers.createCustomer': 'Create New Customer',
  'customers.searchByName': 'Search customers by name...',
  'customers.searchPlaceholder': 'Search customers...',
  'customers.noCustomers': 'No customers found',
  'customers.noSearchResults': 'No search results found',
  'customers.tryDifferentSearch': 'Try a different search term',
  'customers.phone': 'Phone',
  'customers.email': 'Email',
  'customers.call': 'Call',
  'customers.write': 'Write',
  'customers.address': 'Address',
  'customers.taxIdentificationNumber': 'Tax Identification Number',
  'customers.taxIdentificationNumberOptional': 'Optional; enter a VKN, TCKN or other tax identifier',
  'customers.name': 'Name',
  'customers.company': 'Company',
  'customers.noFound': 'No customers found',
  'customers.noYet': 'No customers yet',
  'customers.customerInfo': 'Customer Information',
  'customers.notFound': 'Customer not found',
  'customers.loadError': 'Failed to load customer',
  'customers.getStarted': 'Get started by adding your first customer',
  'customers.addFirstCustomer': 'Add First Customer',
  'customers.saving': 'Saving...',
  'customers.create': 'Create',
  'customers.update': 'Update',
  'customers.deleting': 'Deleting...',
  'customers.created': 'Customer created successfully',
  'customers.updated': 'Customer updated successfully',
  'customers.deleted': 'Customer deleted successfully',
  'customers.errors.invalidEmail': 'Invalid email format',
  'customers.errors.invalidPhone': 'Invalid phone number format',
  'customers.errors.missingField': 'Missing required field',
  'customers.errors.alreadyExists': 'already exists',
  'customers.errors.emailAlreadyExists': 'A customer with this email already exists',
  'customers.errors.taxIdentificationNumberAlreadyExists': 'A customer with this tax identification number already exists',
  'customers.errors.duplicateNameRequiresIdentifier': 'A customer with this name already exists. Add a phone number, email, or tax identification number to distinguish the customer',
  'customers.errors.alreadyExistsInCompany': 'This customer already exists in the company',
  'customers.errors.saveFailed': 'Failed to save customer',
  'customers.deleteWarning': 'This action cannot be undone. All data associated with this customer will be permanently deleted.',
  'customers.deleteQuestion': 'Are you sure you want to delete this customer? This will also delete:',
  'customers.deleteConsequences.allTransactions': 'All transactions with this customer',
  'customers.deleteConsequences.allInvoices': 'All invoices and payment history',
  'customers.deleteConsequences.allData': 'All related customer data',
  
  // Items
  'items.title': 'Items',
  'items.nameRequired': 'Product name is required.',
  'items.invalidCode': 'Use letters, numbers, dots, dashes, underscores, or slashes.',
  'items.priceRequired': 'Enter a valid sale price.',
  'items.pricePositive': 'Sale price must be greater than zero.',
  'items.itemType': 'Item type',
  'items.productType': 'Product',
  'items.serviceType': 'Service',
  'items.defaultPriceOptional': 'Default price (optional)',
  'items.servicePriceHelp': 'The price is entered when the service is sold.',
  'items.servicePriceAtSale': 'Set at sale',
  'items.inventoryNotTracked': 'Not tracked',
  'items.catalogSubtitle': 'Manage products, prices, and stock in one place.',
  'items.lowStock': 'Low stock',
  'items.stockHealthy': 'Stock available',
  'items.openInventory': 'View stock',
  'items.clearFilters': 'Clear filters',
  'items.allCategories': 'All categories',
  'items.management': 'Items Management',
  'items.addItem': 'Add Item',
  'items.editItem': 'Edit Item',
  'items.deleteItem': 'Delete Item',
  'items.addNewItem': 'Add New Item',
  'items.createItem': 'Create New Item',
  'items.itemName': 'Item Name',
  'items.itemNumber': 'Item Code',
  'items.itemNumberHelp': 'Optional memorable code; leave blank to generate one automatically',
  'items.barcode': 'Barcode',
  'items.barcodeHelp': 'Optional value used when searching with a barcode scanner',
  'barcode.scan': 'Scan',
  'barcode.scanTitle': 'Scan barcode',
  'barcode.scannerHint': 'Use the camera, a USB/Bluetooth barcode reader, or enter the code manually.',
  'barcode.scannerInput': 'Scan or enter barcode',
  'barcode.useCode': 'Use code',
  'barcode.startCamera': 'Start camera',
  'barcode.stopCamera': 'Stop camera',
  'barcode.cameraUnavailable': 'Could not start the camera. Allow camera access and open this page over HTTPS, or enter the code manually.',
  'barcode.testTitle': 'Barcode scanner test',
  'barcode.testDescription': 'Try scanning a product barcode with your phone camera. The code appears here and is not saved.',
  'barcode.scanResult': 'Scanned code',
  'barcode.scanEmpty': 'No barcode scanned yet.',
  'items.manageInventory': 'Manage your inventory items',
  'items.searchByName': 'Search items by name...',
  'items.searchPlaceholder': 'Search items...',
  'items.name': 'Name',
  'items.description': 'Description',
  'items.price': 'Price',
  'items.salePrice': 'Sale price',
  'items.vatRate': 'VAT rate',
  'items.vatRateHelp': 'This VAT rate is stored with the item and used for future sales and invoices.',
  'items.vatRateInvalid': 'Choose one of the supported VAT rates: 0%, 1%, 10%, or 20%.',
  'items.vatRatePresets': 'Common VAT rates',
  'items.priceEntryModeHint': 'The price is saved according to your company catalog price entry setting.',
  'items.priceEntryModeVatExcluded': 'excluding VAT',
  'items.priceEntryModeVatIncluded': 'including VAT',
  'items.priceVariesByBatch': 'Varies by batch',
  'items.unit': 'Unit',
  'items.pricePerUnitRequired': 'Price per unit (required)',
  'items.salePricePerUnitRequired': 'Sale price per unit (required)',
  'items.company': 'Company',
  'items.minPrice': 'Min Price',
  'items.invalidPriceRange': 'Enter valid prices with a minimum no greater than the maximum.',
  'items.maxPrice': 'Max Price',
  'items.noItems': 'No items found',
  'items.noSearchResults': 'No search results found',
  'items.tryDifferentSearch': 'Try a different search term',
  'items.noFound': 'No items found',
  'items.noYet': 'No items yet',
  'items.getStarted': 'Get started by adding your first item',
  'items.addFirstItem': 'Add First Item',
  'items.deleteConfirm': 'Are you sure you want to delete this item?',
  'items.bulkUpload': 'Bulk Upload',
  'items.saving': 'Saving...',
  'items.create': 'Create',
  'items.update': 'Update',
  'items.deleting': 'Deleting...',
  'items.created': 'Item created successfully',
  'items.updated': 'Item updated successfully',
  'items.deleted': 'Item deleted successfully',
  'items.deleteWarning': 'This action cannot be undone. All data associated with this item will be permanently deleted.',
  'items.deleteQuestion': 'Are you sure you want to delete this item? This will also delete:',
  'items.deleteConsequences.allTransactions': 'All transactions involving this item',
  'items.deleteConsequences.allHistory': 'All inventory and pricing history',
  'items.deleteConsequences.allData': 'All related item data',
  
  // Categories
  'categories.categories': 'Categories',
  'categories.selectCategories': 'Select categories',
  'categories.filterByCategory': 'Filter by category',
  'categories.manageCategories': 'Manage Categories',
  
  // Help System
  'help.dontShowAgain': 'Don\'t show again',
  'help.gotIt': 'Got it',
  'help.toggleHelp': 'Toggle Help',
  'help.resetHelp': 'Reset',
  'help.helpSettings': 'Help Settings',
  'help.searchPlaceholder': 'Search help topics',
  'help.topicCount': 'topics',
  'help.noResults': 'No help topics match your search.',
  'faq.searchPlaceholder': 'Search questions',
  'faq.noResults': 'No questions match your search.',
  'faq.allTopics': 'All topics',
  'faq.browseTopics': 'Browse by topic',
  'help.pageHelp': 'Page Help',
  'help.contextualHelpDescription': 'Show contextual help tooltips throughout the application',
  'help.availableTopics': 'Available Help Topics',
  'help.topicsDescription': 'These help tooltips appear next to relevant features to guide you through the application.',
  'help.disableInfo': 'You can disable individual help tooltips by clicking "Don\'t show again" on each tooltip, or reset all help using the button below.',
  'help.resetDescription': 'Re-enable all previously disabled help tooltips',
  'help.inventoryManagementDesc': 'How to manage item inventory and stock levels',
  'help.batchTrackingDesc': 'Understanding batch tracking for advanced inventory',
  'help.addCustomerDesc': 'How to add new customers to the system',
  'help.addItemDesc': 'How to add new items and products',
  'help.userManagementDesc': 'Managing users and their roles',
  'help.debtManagementDesc': 'Managing customer debts and payments',
  
  // Page-specific help content
  'help.items.title': 'Items Page Help',
  'help.items.content': 'Search, filter, and manage products and services here. Products can track stock; services do not. Items uploaded in bulk start with zero stock.',
  'help.customers.title': 'Customers Page Help', 
  'help.customers.content': 'Search customers by first or last name and open their details and account history. First and last name are required; customers with sales or debt records cannot be deleted.',
  'help.users.title': 'Users Page Help',
  'help.users.content': 'Create and manage employee accounts. Company Administrators can edit or delete only the users they are allowed to manage.',
  'help.debts.title': 'Customer Accounts Help',
  'help.debts.content': 'Use Customer Accounts to add debt and payment movements. Open a customer’s history by selecting their name; a payment reduces the customer balance.',
  'help.sales.title': 'Sales Page Help',
  'help.sales.content': 'Select a customer, add products to the cart, and complete checkout by recording full, partial, or no payment. Use Sales History to review completed sales and payment status.',
  'help.expenses.title': 'Expenses Page Help',
  'help.expenses.content': 'Record company expenses and purchases, including their category, payment status, and method. Search or filter records by category, status, and date range.',

  // Inventory Management
  'inventory.title': 'Inventory',
  'inventory.invalidQuantity': 'Enter a whole number of zero or more.',
  'inventory.expirationAfterProduction': 'Expiration date cannot be before production date.',
  'inventory.stockOverview': 'Stock overview',
  'inventory.stockOverviewHint': 'Review stock movements and batches here.',
  'inventory.batchSettings': 'Batch settings',
  'inventory.selectBatchToAdjust': 'Select a batch to adjust',
  'inventory.noStockToRemove': 'No stock available to remove',
  'inventory.operationPreview': 'Stock after operation',
  'inventory.management': 'Inventory Management',
  'inventory.manageInventory': 'Manage Inventory',
  'inventory.currentStock': 'Current Stock',
  'inventory.currentPrice': 'Current Price',
  'inventory.editingBatch': 'Editing Batch',
  'inventory.stock': 'Stock',
  'inventory.units': 'units',
  'inventory.addStock': 'Add Stock',
  'inventory.removeStock': 'Remove Stock',
  'inventory.adjustStock': 'Adjust Stock',
  'inventory.adjustStockError': 'Failed to adjust stock',
  'inventory.deleteBatch': 'Delete Batch',
  'inventory.deleteBatchError': 'Failed to delete batch',
  'inventory.deleteBatchConfirm': 'Delete Batch?',
  'inventory.deleteBatchWarning': 'This action cannot be undone.',
  'inventory.deleteBatchMessage': 'Are you sure you want to delete this batch? The batch must have 0 remaining stock to be deleted.',
  'inventory.cannotDeleteBatchWithStock': 'Cannot delete batch with remaining stock. Please adjust stock to 0 first.',
  'inventory.enterBatchNumber': 'Enter batch number',
  'inventory.batchNumberHelpText': 'Update the batch number if needed',
  'inventory.quickActions': 'Quick Actions',
  'inventory.doubleClickBatchToEdit': 'Double-click on a batch in the list to edit its details',
  'inventory.batches': 'Batches',
  'inventory.transactions': 'Transactions',
  'inventory.batchTracking': 'Batch Tracking',
  'inventory.enableBatchTracking': 'Enable Batch Tracking',
  'inventory.batchTrackingHelp': 'Track individual batches with production dates and expiration dates',
  'inventory.simpleInventoryHelp': 'Track stock as one total quantity without batch details.',
  'inventory.batchTracked': 'Batch Tracked',
  'inventory.activeBatches': 'active batches',
  'inventory.price': 'Price',
  'inventory.salePrice': 'Sale price',
  'inventory.priceEntryModeHelp': 'Enter the price {mode}.',
  'inventory.priceEntryModeVatExcluded': 'excluding VAT',
  'inventory.priceEntryModeVatIncluded': 'including VAT',
  'inventory.quantity': 'Quantity',
  'inventory.batchNumber': 'Batch Number',
  'inventory.batchNumberPlaceholder': 'Enter the batch number for the initial stock',
  'inventory.batchSelection': 'Batch',
  'inventory.newBatch': 'Create a new batch',
  'inventory.selectExistingBatch': 'Add to an existing batch',
  'inventory.batchStockOption': '{batchNumber} ({quantity} units)',
  'inventory.existingBatchPriceHelp': 'The existing batch sale price is kept.',
  'inventory.batchSalePrice': 'Batch sale price',
  'inventory.newBatchPriceHelp': 'Set the sale price for this new batch. It defaults to the product price.',
  'inventory.batchPriceEditHelp': 'Changing this price affects this batch only. Previous sales keep their price.',
  'inventory.productionDate': 'Production Date',
  'inventory.expirationDate': 'Expiration Date',
  'inventory.notes': 'Notes',
  'inventory.notesPlaceholder': 'Add notes about this stock operation...',
  'inventory.advancedOptions': 'Advanced Options',
  'inventory.summary': 'Summary',
  'inventory.newTotal': 'New Total',
  'inventory.quantityToRemove': 'Quantity to Remove',
  'inventory.available': 'Available',
  'inventory.reasonForRemoval': 'Reason for removal (optional)',
  'inventory.outOfStock': 'Out of Stock',
  'inventory.newQuantity': 'New Quantity',
  'inventory.currentQuantity': 'Current Quantity',
  'inventory.reasonForAdjustment': 'Reason for adjustment (optional)',
  'inventory.change': 'Change',
  'inventory.increase': 'Increase',
  'inventory.decrease': 'Decrease',
  'inventory.initialStock': 'Initial Stock',
  'inventory.initialStockHelp': 'Starting quantity for this item',
  'inventory.batchDetails': 'Batch Details',
  'inventory.noBatches': 'No batches found for this item',
  'inventory.noBatchNumber': 'No batch number',
  'inventory.remaining': 'Remaining',
  'inventory.status': 'Status',
  'inventory.active': 'Active',
  'inventory.expired': 'Expired',
  'inventory.expiringSoon': 'Expiring Soon',
  'inventory.empty': 'Empty',
  'inventory.batchSummary': 'Batch Summary',
  'inventory.totalBatches': 'Total Batches',
  'inventory.expiredBatches': 'Expired Batches',
  'inventory.expiringSoonBatches': 'Expiring Soon Batches',
  'inventory.batchTotal': 'Batch Total',
  'inventory.financialSummary': 'Financial Summary',
  'inventory.totalQuantity': 'Total Quantity',
  'inventory.totalValue': 'Total Value',
  'inventory.transactionHistory': 'Transaction History',
  'inventory.noTransactions': 'No transactions found for this item',
  'inventory.type': 'Type',
  'inventory.before': 'Before',
  'inventory.after': 'After',
  'inventory.user': 'User',
  'inventory.date': 'Date',
  'inventory.transactionType.add': 'Add',
  'inventory.transactionType.remove': 'Remove',
  'inventory.transactionType.adjust': 'Adjust',
  'inventory.transactionType.sale': 'Sale',
  'inventory.transactionType.modeChange': 'Mode change',
  'inventory.transactionNotes.batchToSimple': 'Batch tracking was disabled and stock was consolidated into simple inventory.',
  'inventory.transactionNotes.stockConsolidated': 'Stock was consolidated into simple inventory.',
  'inventory.transactionNotes.legacyRowConsolidated': 'A legacy simple-inventory row was consolidated during the batch transition.',
  'inventory.transactionNotes.legacySimpleToBatch': 'Legacy simple inventory was converted to batch tracking.',
  'inventory.transactionNotes.simpleToBatch': 'Simple inventory was converted to batch tracking.',
  'inventory.transactionSummary': 'Transaction Summary',
  'inventory.totalTransactions': 'Total Transactions',
  'inventory.additions': 'Additions',
  'inventory.removals': 'Removals',
  'inventory.adjustments': 'Adjustments',
  'inventory.selectBatch': 'Select Batch',
  'inventory.autoSelectFIFO': 'Auto-select (FIFO)',
  'inventory.inBatch': 'in batch',
  'inventory.selectedBatch': 'Selected Batch',
  'inventory.batchInfo': 'Batch Info',
  'inventory.adjustStockBatchInfo': 'Note: Adjusting total stock for batch-tracked items will use FIFO logic to remove excess stock or add to the oldest batch.',
  'inventory.addingSummary': 'Adding',
  'inventory.removingSummary': 'Removing',
  'inventory.total': 'Total',
  'inventory.batchTrackingToggleError': 'Failed to toggle batch tracking',
  'inventory.cannotDisableBatchTrackingMultiple': 'Available stock from all batches will be consolidated into simple inventory.',
  'inventory.cannotDisableBatchTrackingStock': 'Available batch stock will be consolidated into simple inventory.',
  'inventory.cannotDisableBatchTrackingBackend': 'Sales history and transaction records remain unchanged during the switch.',
  'inventory.batchNumberRequired': 'Batch number is required when batch tracking is enabled.',
  'inventory.batchNumberRequiredForExistingStock': 'Enter a batch number before enabling tracking for existing stock.',
  'inventory.batchNumberOptionalForExistingStock': 'Optional. If omitted, the system creates a transition batch automatically.',
  'inventory.batchNumberAlreadyExists': 'This batch number already exists for this item.',
  'inventory.itemNotFound': 'The item could not be found.',
  'inventory.inventoryNotTracked': 'This item does not use inventory tracking.',
  'inventory.inventoryModeUnchanged': 'This inventory mode is already selected.',
  'inventory.inventoryTransitionNotAllowed': 'This inventory mode change is not allowed for the item.',
  'inventory.inventoryTransitionFailed': 'The inventory mode could not be changed. Please try again.',
  'inventory.enableBatchTrackingConfirmTitle': 'Enable batch tracking?',
  'inventory.enableBatchTrackingConfirmMessage': 'Existing stock will be placed in one batch. You can optionally provide its batch number.',
  'inventory.disableBatchTrackingConfirmTitle': 'Switch to simple inventory?',
  'inventory.disableBatchTrackingConfirmMessage': 'Available stock from all batches will be consolidated into simple inventory. Sales history and transaction records will remain unchanged.',

  
  // Bulk Upload
  'bulkUpload.bulkUploadItems': 'Bulk Upload Items',
  'bulkUpload.selectCompany': 'Select Company *',
  'bulkUpload.selectFile': 'Select CSV File',
  'bulkUpload.selectCsvFile': 'Select CSV File',
  'bulkUpload.downloadTemplate': 'Download Template',
  'bulkUpload.uploadCustomers': 'Upload Customers',
  'bulkUpload.uploadItems': 'Upload Items',
  'bulkUpload.uploadResults': 'Upload Results',
  'bulkUpload.uploadDescription': 'Upload multiple items from a CSV file. The file must contain "name" and "price" columns. Optional columns: "vatRate" (0, 1, 10, or 20), "categories" (comma-separated category names), "itemNumber", and "barcode".',
  'bulkUpload.uploadingItems': 'Uploading items...',
  'bulkUpload.successfullyCreatedItems': 'Successfully Created Items',
  'bulkUpload.andMore': 'and {{count}} more',
  'bulkUpload.andMoreErrors': 'and {{count}} more errors',
  'bulkUpload.total': 'Total',
  'bulkUpload.success': 'Success',
  'bulkUpload.errors': 'Errors',
  'bulkUpload.pleaseSelectCsvFile': 'Please select a CSV file',
  'bulkUpload.pleaseSelectFile': 'Please select a file',
  'bulkUpload.pleaseSelectCompany': 'Please select a company',
  'bulkUpload.failedToLoadCompanies': 'Failed to load companies',
  'bulkUpload.uploadComplete': 'Bulk upload completed successfully',
  'bulkUpload.rowError': 'Error at row {0}: {1}',
  'bulkUpload.uploadFailed': 'Upload failed. Please try again.',
  'bulkUpload.firstNameRequired': 'First name is required',
  'bulkUpload.lastNameRequired': 'Last name is required',
  'bulkUpload.invalidEmail': 'Invalid email format',
  'bulkUpload.taxIdTooLong': 'Tax identification number must not exceed 32 characters',
  'bulkUpload.itemNameRequired': 'Item name is required',
  'bulkUpload.priceRequired': 'Price is required',
  'bulkUpload.priceNonNegative': 'Price must be non-negative',
  'bulkUpload.priceInvalid': 'Price must be a valid number',
  'bulkUpload.codeInvalid': 'Code contains invalid characters',
  'bulkUpload.fileEmpty': 'File is empty',
  'bulkUpload.fileMustBeCsv': 'File must be a CSV file',
  'bulkUpload.processingError': 'Error processing CSV file',
  'bulkUpload.companyNotFound': 'Company not found',
  'bulkUpload.companyRequired': 'Super admin must specify company ID',
  'bulkUpload.userCompanyRequired': 'User must be associated with a company',
  'bulkUpload.customerHeadersRequired': "CSV must contain 'firstName' and 'lastName' columns",
  'bulkUpload.itemHeadersRequired': "CSV must contain 'name' and 'price' columns. Optional: 'itemNumber', 'barcode', 'vatRate' (0, 1, 10, or 20), 'categories'",
  'bulkUpload.vatRateInvalid': 'VAT rate must be 0, 1, 10, or 20',
  'bulkUpload.vatRateNumberInvalid': 'VAT rate must be a valid number',
  'bulkUpload.customerAlreadyExists': "Customer '{{value}}' already exists",
  'bulkUpload.customerEmailAlreadyExists': 'A customer with this email already exists',
  'bulkUpload.customerTaxIdentificationNumberAlreadyExists': 'A customer with this tax identification number already exists',
  'bulkUpload.duplicateNameRequiresIdentifier': 'A customer with this name already exists; add a phone number, email, or tax identification number to distinguish the customer',
  'bulkUpload.customerAlreadyExistsInCompany': 'This customer already exists in the company',
  'bulkUpload.customerRowProcessingError': 'Customer row could not be processed',
  'bulkUpload.itemAlreadyExists': "Item '{{value}}' already exists",
  'bulkUpload.itemNumberAlreadyExists': "Item number '{{value}}' already exists",
  'bulkUpload.barcodeAlreadyExists': "Barcode '{{value}}' already exists",

  // Bulk Upload Customers
  'bulkUploadCustomers.bulkUploadCustomers': 'Bulk Upload Customers',
  'bulkUploadCustomers.uploadDescription': 'Upload multiple customers from a CSV file. Required columns: "firstName" and "lastName". Optional columns: "email", "phone", "address", "taxIdentificationNumber".',
  'bulkUploadCustomers.uploadingCustomers': 'Uploading customers...',
  'bulkUploadCustomers.successfullyCreatedCustomers': 'Successfully Created Customers',
  
  // Dashboard
  'dashboard.welcome': 'Welcome to Veresiye',
  'dashboard.quickActions': 'Quick Actions',
  'dashboard.recentActivity': 'Recent Activity',
  
  // Quick Actions
  'quickActions.newSale': 'New Sale',
  'quickActions.newSaleDesc': 'Create a new sale record',
  'quickActions.addCustomer': 'Add Customer',
  'quickActions.addCustomerDesc': 'Create a new customer profile',
  'quickActions.addItem': 'Add Item',
  'quickActions.addItemDesc': 'Add new inventory item',
  'quickActions.addDebt': 'Add Debt',
  'quickActions.addDebtDesc': 'Record new customer debt',
  'quickActions.addPayment': 'Add Payment',
  'quickActions.addPaymentDesc': 'Record customer payment',
  'quickActions.addUser': 'Add User',
  'quickActions.addUserDesc': 'Create new user account',
  'quickActions.enabledActions': 'Enabled Actions',
  'quickActions.availableActions': 'Available Actions',
  'quickActions.dragToReorder': 'Drag the handle or use the up/down arrow keys to reorder',
  'quickActions.searchCustomer': 'Search Customer',
  'quickActions.searchCustomerDesc': 'Find existing customers',
  'quickActions.browseItems': 'Browse Items',
  'quickActions.browseItemsDesc': 'View all inventory items',
  'quickActions.scanBarcode': 'Scan Barcode',
  'quickActions.scanBarcodeDesc': 'Find a product by barcode',
  'quickActions.noActionsAvailable': 'No quick actions available. Click the settings icon to customize your actions.',
  'quickActions.customizeActions': 'Customize Quick Actions',
  'quickActions.categories.customer': 'Customer',
  'quickActions.categories.item': 'Item',
  'quickActions.categories.user': 'User',
  'quickActions.categories.search': 'Search',
  'quickActions.categories.debt': 'Debt',
  'quickActions.categories.other': 'Other',
  
  // Sales
  'sales.pageDescription': 'Choose a customer, add products, and complete the sale with confidence.',
  'sales.invalidPaymentAmount': 'Enter a valid payment amount.',
  'sales.partialPaymentRange': 'A partial payment must be greater than zero and less than the total.',
  'sales.noSales': 'No sales have been recorded yet.',
  'sales.noSearchResults': 'No sales match these filters.',
  'sales.shopping': 'Shopping',
  'sales.salesHistory': 'Sales History',
  'sales.companyScope': 'Company scope',
  'sales.selectCustomer': 'Select Customer',
  'sales.stepCustomer': 'Customer',
  'sales.stepItems': 'Items',
  'sales.stepCart': 'Cart',
  'sales.continueToItems': 'Choose Items',
  'sales.backToCustomer': 'Back to Customer',
  'sales.reviewCart': 'Review Cart',
  'sales.backToItems': 'Back to Items',
  'sales.selectedCustomer': 'Selected Customer',
  'sales.searchCustomers': 'Search Customers',
  'sales.newCustomer': 'New Customer',
  'sales.createCustomer': 'Create New Customer',
  'sales.creating': 'Creating...',
  'sales.addItems': 'Add Items to Cart',
  'sales.searchItems': 'Search Items',
  'sales.category': 'Category',
  'sales.allCategories': 'All Categories',
  'sales.price': 'Price',
  'sales.inStock': 'in stock',
  'sales.inStockGroup': 'In stock',
  'sales.outOfStockGroup': 'Out of stock',
  'sales.outOfStock': 'Out of stock',
  'sales.stockQuantity': 'Stock',
  'sales.servicePriceRequired': 'Enter the service price.',
  'sales.servicePriceHelp': 'Set the price for this service sale.',
  'sales.priceEntryModeHelp': 'Enter this price {mode}.',
  'sales.priceEntryModeVatExcluded': 'excluding VAT',
  'sales.priceEntryModeVatIncluded': 'including VAT',
  'sales.inventoryNotTracked': 'Inventory not tracked',
  'sales.batchTracked': 'Batch Tracked',
  'sales.add': 'Add',
  'sales.addToCart': 'Add to Cart',
  'sales.adding': 'Adding...',
  'sales.select': 'Select',
  'sales.selected': 'Selected',
  'sales.noCustomersFound': 'No customers found',
  'sales.noCustomersAvailable': 'No customers available',
  'sales.failedToLoadItems': 'Failed to load items',
  'sales.noItemsFound': 'No items found',
  'sales.searchItemsPlaceholder': 'Type to search items...',
  'sales.barcodeNotFound': 'No product was found for this barcode',
  'sales.batchPrice': 'batch price',
  'sales.shoppingCart': 'Shopping Cart',
  'sales.yourCartIsEmpty': 'Your cart is empty',
  'sales.addItemsToStart': 'Add items to start shopping',
  'sales.clearCart': 'Clear Cart',
  'sales.customer': 'Customer',
  'sales.batch': 'Batch',
  'sales.unitPrice': 'Unit Price',
  'sales.unitNetPrice': 'Unit Net',
  'sales.netAmount': 'Net amount',
  'sales.vatRate': 'VAT rate',
  'sales.vatAmount': 'VAT amount',
  'sales.grossAmount': 'Total including VAT',
  'sales.checkout': 'Checkout',
  'sales.completeSale': 'Complete Sale',
  'sales.orderSummary': 'Order Summary',
  'sales.saleSummary': 'Sale Summary',
  'sales.totalAmount': 'Total Amount',
  'sales.paymentType': 'Payment Type',
  'sales.fullPaid': 'Full Paid',
  'sales.partialPaid': 'Partial Paid',
  'sales.noPayment': 'No Payment',
  'sales.paymentAmount': 'Payment Amount',
  'sales.paymentMethod': 'Payment Method',
  'sales.cash': 'Cash',
  'sales.card': 'Card',
  'sales.bankTransfer': 'Bank Transfer',
  'sales.check': 'Check',
  'sales.other': 'Other',
  'sales.paymentNotes': 'Payment Notes',
  'sales.remainingAmountDebt': 'Remaining amount will be recorded as debt',
  'sales.fullAmountDebt': 'Full amount will be recorded as debt',
  'sales.cancel': 'Cancel',
  'sales.processing': 'Processing...',
  'sales.quantity': 'Quantity',
  'sales.invalidQuantity': 'Enter a whole number greater than 0',
  'sales.noBatchesAvailable': 'No batches available',
  'sales.available': 'Available',
  'sales.expires': 'Expires',
  'sales.notesOptional': 'Notes (Optional)',
  'sales.selectBatch': 'Select Batch',
  'sales.total': 'Total',
  'sales.changeCustomer': 'Change Customer',
  'sales.typeToSearchCustomer': 'Type to search customer...',
  'sales.paymentSuccess': 'Payment completed successfully!',
  'sales.pleaseSelectCustomerFirst': 'Please select a customer first',
  'sales.saleCompletedSuccessfully': 'Sale completed successfully!',
  'sales.selectCustomerBeforeAdding': 'Please select a customer before adding items to the cart',
  'sales.failedToAddItem': 'Failed to add item to cart',
  'sales.failedToUpdateQuantity': 'Failed to update item quantity',
  'sales.failedToRemoveItem': 'Failed to remove item from cart',
  'sales.failedToCreateSession': 'Failed to create shopping session',
  'sales.failedToValidateStock': 'Failed to validate stock',
  'sales.failedToCompleteSale': 'Failed to complete sale',
  'sales.noActiveSaleToComplete': 'No active sale to complete',
  'sales.shoppingSession': 'Shopping session',
  'sales.items': 'items',
  'sales.created': 'Created',
  'sales.resume': 'Resume',
  'sales.salesHistoryWillBeImplemented': 'Sales history will be implemented here',
  'sales.thisItemUsesBatchTracking': 'This item uses batch tracking',
  'sales.failedToLoadCustomers': 'Failed to load customers',
  'sales.failedToCreateCustomer': 'Failed to create customer',
  'sales.searchBySaleNumber': 'Search by Sale Number',
  'sales.enterSaleNumber': 'Enter sale number...',
  'sales.searchByCustomer': 'Search by Customer',
  'sales.searchCustomerPlaceholder': 'Search customer...',
  'sales.enterCustomerName': 'Enter customer name...',
  'sales.previousPage': 'Previous page',
  'sales.nextPage': 'Next page',
  'sales.paymentStatus': 'Payment Status',
  'sales.completed': 'Completed',
  'sales.cancelled': 'Cancelled',
  'sales.paid': 'Paid',
  'sales.partiallyPaid': 'Partially Paid',
  'sales.unpaid': 'Unpaid',
  'sales.saleNumber': 'Sale Number',
  'sales.itemNumber': 'Item Number',
  'sales.saleDate': 'Sale Date',
  'sales.paidAmount': 'Paid Amount',
  'sales.remainingAmount': 'Remaining Amount',
  'sales.saleDetails': 'Sale Details',
  'sales.createdBy': 'Created By',
  'sales.notes': 'Notes',
  'sales.pageSize': 'Page Size',
  'sales.item': 'Item',
  'sales.typeAtLeastTwoCharacters': 'Type at least 2 characters',
  'sales.typeCustomerName': 'Type customer name...',
  'sales.all': 'All',

  // Debts
  'debts.title': 'Customer Accounts',
  'debts.pageDescription': 'Every account movement with your customers, in one place.',
  'debts.ledgerTitle': 'Account movements',
  'debts.ledgerDescription': 'Review debts and payments in date order.',
  'debts.totalRecords': 'Total records',
  'debts.page': 'Page',
  'debts.filters': 'Filters',
  'debts.activeFilters': 'Active filters:',
  'debts.showResults': 'Show results',
  'debts.sort': 'sort',
  'debts.openCustomerAccount': 'Open customer account',
  'debts.clearSearch': 'Clear search',
  'debts.searchPlaceholderShort': 'Search customer or description',
  'debts.previousPage': 'Previous page',
  'debts.nextPage': 'Next page',
  'debts.rowsPerPage': 'Records per page',
  'debts.helpSummary': 'Use the action buttons to add a debt or payment. Select a customer name to open their account; use Filters for dates and amounts, and Columns to choose visible fields. Sale movements remain linked to their sale record.',
  'debts.invalidDateRange': 'Start date cannot be after end date',
  'debts.filter.startDate': 'Start date',
  'debts.filter.endDate': 'End date',
  'debts.filter.minAmount': 'Minimum amount',
  'debts.filter.maxAmount': 'Maximum amount',
  'debts.filter.createdBy': 'Created by',
  'debts.filter.companyId': 'Company',
  'debts.subtitle': 'Sales, debts, payments and cancellation movements in one ledger',
  'debts.addDebt': 'Add Debt',
  'debts.createDebt': 'Create New Debt',
  'debts.form.debtHint': 'Add an amount owed to the customer account.',
  'debts.form.paymentHint': 'Record a payment received from the customer.',
  'debts.form.debtAmountHint': 'This amount increases the customer balance owed to you.',
  'debts.form.paymentAmountHint': 'This amount reduces the customer balance owed to you.',
  'debts.form.saveDebt': 'Save debt',
  'debts.form.savePayment': 'Save payment',
  'debts.editDebt': 'Edit Debt',
  'debts.editPayment': 'Edit Payment',
  'debts.deleteDebt': 'Delete Debt',
  'debts.customer': 'Customer',
  'debts.company': 'Company',
  'debts.amount': 'Amount',
  'debts.transactionDate': 'Transaction Date',
  'debts.transactionDateTime': 'Transaction Date & Time',
  'debts.movementType': 'Movement Type',
  'debts.manualDebt': 'Debt',
  'debts.saleNumber': 'Sale Number',
  'debts.year': 'Year',
  'debts.month': 'Month',
  'debts.allYears': 'All Years',
  'debts.allMonths': 'All Months',
  'debts.minAmount': 'Min Amount',
  'debts.maxAmount': 'Max Amount',
  'debts.invalidAmountRange': 'Minimum amount cannot be greater than maximum amount',
  'debts.paymentAmount': 'Payment Amount',
  'debts.description': 'Description',
  'debts.createdBy': 'Created By',
  'debts.addPayment': 'Add Payment',
  'debts.createPayment': 'Record Payment',
  'debts.payment': 'Payment',
  'debts.customerRequired': 'Customer is required',
  'debts.amountRequired': 'Amount is required',
  'debts.amountInvalid': 'Amount must be a positive number',
  'debts.descriptionPlaceholder': 'Optional description for this debt...',
  'debts.noDescription': 'No description',
  'debts.newCustomerWillBeCreated': 'New customer will be created',
  'debts.searchPlaceholder': 'Search by customer name, description, amount, or creator...',
  'debts.loadError': 'Failed to load debts',
  'debts.createError': 'Failed to create debt',
  'debts.updateError': 'Failed to update debt',
  'debts.deleteError': 'Failed to delete debt',
  'debts.deleteConfirmation': 'Are you sure you want to delete this debt? This action cannot be undone.',
  'debts.deleteWarning': 'This will permanently remove the debt record from the system.',
  'debts.totalDebt': 'Total Debt',
  'debts.totalCredit': 'Total Credit',
  'debts.filter': 'Show',
  'debts.allRecords': 'All',
  'debts.debtEntries': 'Debts',
  'debts.paymentEntries': 'Payments',
  'debts.debtRecord': 'debt record',
  'debts.debtRecords': 'debt records',
  'debts.paymentRecord': 'payment record',
  'debts.paymentRecords': 'payment records',
  'debts.sale': 'Sale',
  'debts.paymentForSale': 'Payment for Sale',
  'debts.manualPayment': 'Payment',
  'debts.salePaidSummary': 'Fully paid',
  'debts.salePartialSummary': 'Partially paid',
  'debts.saleUnpaidSummary': 'Unpaid',
  'debts.remainingAmountShort': 'Remaining',
  'debts.saleCancellation': 'Sale cancellation',
  'debts.movement': 'Account movement',
  'debts.saleMovementReadOnly': 'Sale movements cannot be edited or deleted',
  'debts.noDebts': 'No account movements yet',
  'debts.addFirstDebt': 'Get started by adding your first debt or payment',
  'debts.noSearchResults': 'No search results found',
  'debts.tryDifferentSearch': 'Try a different search term',

  'customerDetail.backToCustomers': 'Back to customers',
  'customerDetail.currentBalance': 'CURRENT BALANCE',
  'customerDetail.customerOwes': 'The customer owes you',
  'customerDetail.youOwe': 'You owe the customer',
  'customerDetail.noBalance': 'No balance due',
  'customerDetail.balanceCaption': 'This amount reflects the difference between recorded debts and payments.',
  'customerDetail.infoSubtitle': 'Contact and customer record details',
  'customerDetail.infoEmpty': 'No additional customer information.',
  'customerDetail.movements': 'Account movements',
  'customerDetail.filterDates': 'Filter by date',
  'customerDetail.shareDebtSummary': 'Share debt summary',
  'customerDetail.shareDebtSummaryTitle': 'Share debt summary',
  'customerDetail.shareDebtSummaryHint': 'Review and edit the message before sending it.',
  'customerDetail.shareMessageLabel': 'Message to send',
  'customerDetail.whatsappShare': 'Share via WhatsApp',
  'customerDetail.downloadPdf': 'Download PDF',
  'customerDetail.sharePdf': 'Share as PDF',
  'customerDetail.pdfPreparing': 'Preparing PDF...',
  'customerDetail.pdfShareFallback': 'Device sharing is not supported, so the PDF was downloaded instead.',
  'customerDetail.shareFailed': 'The share action could not be started. Please try again.',
  'customerDetail.summaryTitle': 'Debt Summary',
  'customerDetail.summaryCustomer': 'Customer',
  'customerDetail.summaryBalance': 'Current balance',
  'customerDetail.summaryDate': 'Created on',
  'customerDetail.summaryPeriod': 'Movement period',
  'customerDetail.sharePeriod': 'Movement period',
  'customerDetail.lastMonth': 'Last 1 month',
  'customerDetail.lastTwoMonths': 'Last 2 months',
  'customerDetail.lastYear': 'Last year',
  'customerDetail.allMovements': 'All movements',
  'customerDetail.customRange': 'Custom date range',
  'customerDetail.summaryRecentMovements': 'Recent movements',
  'customerDetail.summaryNoMovements': 'No recent movements.',
  'customerDetail.summaryDebt': 'Debt',
  'customerDetail.summaryPayment': 'Payment',
  'customerDetail.summaryNoDescription': 'No description',

  // Expenses
  'expenses.title': 'Expense Ledger',
  'expenses.formHint': 'Record what the expense was for and whether it has been paid.',
  'expenses.amountHint': 'Enter the amount in Turkish lira.',
  'expenses.paidHint': 'Check this when payment is complete.',
  'expenses.clearSearch': 'Clear search',
  'expenses.invalidDateRange': 'Start date cannot be after end date.',
  'expenses.subtitle': 'Track company expenses, purchases and payments',
  'expenses.addExpense': 'Add Expense',
  'expenses.editExpense': 'Edit Expense',
  'expenses.createExpense': 'New Expense Record',
  'expenses.description': 'Description',
  'expenses.descriptionPlaceholder': 'E.g. products purchased from wholesaler',
  'expenses.category': 'Category',
  'expenses.categoryPlaceholder': 'E.g. purchase, rent, bill',
  'expenses.amount': 'Amount',
  'expenses.date': 'Transaction date',
  'expenses.paid': 'Paid',
  'expenses.unpaid': 'Unpaid',
  'expenses.paymentMethod': 'Payment method',
  'expenses.notes': 'Note',
  'expenses.optional': 'Optional',
  'expenses.status': 'Status',
  'expenses.searchPlaceholder': 'Search by description, category or note...',
  'expenses.allStatuses': 'All statuses',
  'expenses.allCategories': 'All categories',
  'expenses.startDate': 'Start date',
  'expenses.endDate': 'End date',
  'expenses.cash': 'Cash',
  'expenses.card': 'Card',
  'expenses.bankTransfer': 'Bank transfer',
  'expenses.check': 'Check',
  'expenses.other': 'Other',
  'expenses.noExpenses': 'No expense records yet',
  'expenses.noSearchResults': 'No search results found',
  'expenses.deleteExpense': 'Delete Expense',
  'expenses.deleteConfirmation': 'Are you sure you want to delete this expense record?',
  'expenses.createError': 'Failed to create expense record',
  'expenses.loadError': 'Failed to load expense records',
  'expenses.updateError': 'Failed to update expense record',
  'expenses.deleteError': 'Failed to delete expense record',
  'expenses.descriptionRequired': 'Description is required',
  'expenses.amountRequired': 'Enter a valid positive amount',
  'expenses.dateRequired': 'Transaction date is required',
  
  // App & Landing
  'app.description': 'Stock, CRM and Debt Tracking System',
  'app.tagline': 'Customer, stock, sales, and balance records in one place',
  'landing.heroTitle': 'Records in order. Balances in view.',
  'landing.eyebrow': 'Electronic credit, clear records',
  'landing.workflowTitle': 'A clear view of your business',
  'landing.workflowDesc': 'Customer, stock, sales, and open-account data — organized and traceable in one place.',
  'landing.previewLabel': 'Key records in one view',
  'landing.footerNote': 'Clear records. An orderly workflow.',
  'landing.heroSubtitle': 'Record customer, inventory, sales, and open-account activity in one digital workspace. Review recent changes and balances at a glance.',
  'landing.getStarted': 'Get Started',
  'landing.login': 'Sign In',
  'landing.featuresTitle': 'A clear place for every record',
  'landing.featuresSubtitle': 'Keep customer, inventory, sales, and balance activity organized and easy to review.',
  'landing.featureCustomersTitle': 'Customer Management',
  'landing.featureCustomersDesc': 'Keep customer details and transaction history together in an orderly record.',
  'landing.featureInventoryTitle': 'Stock & Inventory',
  'landing.featureInventoryDesc': 'Track products, stock levels, batch tracking and inventory movements.',
  'landing.featureSalesTitle': 'Sales & Checkout',
  'landing.featureSalesDesc': 'Process sales with cash, card or credit — full or partial payments supported.',
  'landing.featureDebtsTitle': 'Debt Tracking',
  'landing.featureDebtsDesc': 'Track debts, payments, and balance changes in detailed records.',
  'landing.featureMultiTenantTitle': 'Multi-Company',
  'landing.featureMultiTenantDesc': 'Keep company records separate and manage access by user role.',
  'landing.ctaTitle': 'Put your records in order.',
  'landing.ctaSubtitle': 'Record and review customer, inventory, sales, and balance data in one digital workspace.',
  'landing.createAccount': 'Create Account',
  'landing.alreadyHaveAccount': 'Already have an account?',
  'landing.learnMore': 'Learn More',
  'landing.metricSales': 'Sales today',
  'landing.metricBalance': 'Open balance',
  'landing.activityTitle': 'A week at a glance',
  'landing.footerBrandLine': 'Accurate records. Clear decisions.',
  'landing.footerLinks': 'Explore',
  'landing.footerLogin': 'Log in',
  'landing.footerRegister': 'Sign up',
  'landing.brandPage': 'Brand',
  'landing.contactLabel': 'Contact',
  'landing.contactEmail': 'hello@yazbiveresiye.com',
  'landing.rights': 'All rights reserved.',
  'role.SUPER_ADMIN': 'Super Admin',
  'role.COMPANY_ADMIN': 'Company Admin',
  'role.EMPLOYEE': 'Employee',
  
  // Themes
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.switchTheme': 'Switch Theme',
  
  // Language
  'language.switchLanguage': 'Switch Language',
  
  // Profile
  'profile.preferences': 'Theme & Language',
  'profile.preferencesHint': 'Choose a theme and language that work best for you.',
  'profile.appearance': 'Theme',
  'profile.language': 'Language',
  'profile.showPassword': 'Show password',
  'profile.hidePassword': 'Hide password',
  'profile.personalInfo': 'Personal Information',
  'profile.edit': 'Edit',
  'profile.editProfile': 'Edit Profile',
  'profile.managedByCompanyAdmin': 'Your profile is managed by your company administrator.',
  'profile.openMenu': 'Profile Menu',
  'profile.firstName': 'First Name',
  'profile.firstNameRequired': 'First name is required',
  'profile.lastName': 'Last Name',
  'profile.lastNameRequired': 'Last name is required',
  'profile.username': 'Username',
  'profile.usernameRequired': 'Username is required',
  'profile.usernameMinLength': 'Username must be at least 3 characters',
  'profile.usernameMaxLength': 'Username must be no more than 50 characters',
  'profile.email': 'Email',
  'profile.role': 'Role',
  'profile.changePassword': 'Change Password (Optional)',
  'profile.emailRequired': 'Email address is required',
  'profile.emailInvalid': 'Please enter a valid email address',
  'profile.currentPassword': 'Current Password',
  'profile.currentPasswordRequiredForPassword': 'Enter your current password to change it',
  'profile.newPassword': 'New Password',
  'profile.newPasswordRequired': 'New password is required',
  'profile.newPasswordMinLength': 'New password must be at least 6 characters',
  'profile.confirmPassword': 'Confirm New Password',
  'profile.passwordsMismatch': 'Passwords do not match',
  'profile.saveChanges': 'Save Changes',
  'profile.cancel': 'Cancel',
  'profile.companyInfo': 'Company Information & Preferences',
  'profile.referralCode': 'My referral code',
  'profile.referralCodeHint': 'Share this code so new businesses can identify you as their referrer.',
  'profile.createReferralCode': 'Create referral code',
  'profile.copyReferralCode': 'Copy referral code',
  'profile.copyReferralLink': 'Copy sharing link',
  'profile.referralCodeCreated': 'Your referral code was created.',
  'profile.referralCodeCopied': 'Referral code copied.',
  'profile.referralLinkCopied': 'Sharing link copied.',
  'profile.referralCodeCopyError': 'Copy failed. You can select and copy the text manually.',
  'profile.referralCodeError': 'Unable to create a referral code.',
  'profile.referralCodeInactive': 'Your referral code is currently unavailable.',
  'profile.pricingSettings': 'Pricing and VAT',
  'profile.editPricingSettings': 'Edit pricing and VAT settings',
  'profile.pricingSettingsHint': 'Choose whether catalog prices include VAT and set the default VAT rate for new items.',
  'profile.priceEntryMode': 'Catalog price entry',
  'profile.priceEntryModeHint': 'Choose whether new catalog and stock prices are entered including or excluding VAT.',
  'profile.priceEntryModeVatExcluded': 'Prices exclude VAT',
  'profile.priceEntryModeVatIncluded': 'Prices include VAT',
  'profile.priceEntryModeSaved': 'Price entry preference saved.',
  'profile.priceEntryModeSaveError': 'Price entry preference could not be saved.',
  'profile.defaultVatRate': 'Default VAT rate for new items',
  'profile.defaultVatRateHint': 'New items start with this rate. Each item can use a different rate.',
  'profile.defaultVatRateInvalid': 'Choose one of the supported VAT rates: 0%, 1%, 10%, or 20%.',
  'profile.pricingSettingsSaved': 'Pricing settings saved.',
  'profile.batchTrackingEnabled': 'I use batch tracking',
  'profile.batchTrackingSetting': 'Product Batch Tracking',
  'profile.batchTrackingHint': 'Enable batch fields such as batch numbers and expiration dates for your company.',
  'profile.batchTrackingSaved': 'Batch tracking setting saved.',
  'profile.batchTrackingSave': 'Save batch setting',
  'profile.batchTrackingSaveError': 'Batch tracking setting could not be saved.',
  'profile.batchTrackingDisableError': 'This setting cannot be disabled while the company has batch-tracked items. Switch them to simple inventory first.',
  'profile.company': 'Company',
  'profile.noCompany': 'No company assigned',
  'profile.updateSuccess': 'Profile updated successfully',
  'profile.emailVerificationSent': 'Verification email sent to the new address',
  'profile.emailVerificationPending': 'Email verification pending',
  'profile.verifyEmail': 'Verify email',
  'profile.currentPasswordRequiredForEmail': 'Current password is required to change your email',
  'profile.updateError': 'Failed to update profile',
  'profile.loadError': 'Unable to load user information',
  
  // Dashboard
  'dashboard.title': 'Dashboard',
  'dashboard.homeTitle': 'Home',
  'dashboard.homeHint': 'Start daily work quickly and see how your business is doing today.',
  'dashboard.homeLoadError': 'Home data could not be loaded.',
  'dashboard.dataLimitError': 'Dashboard data exceeds the safe display limit. Narrow the selected period and try again.',
  'dashboard.monthSummary': 'This month at a glance',
  'dashboard.monthSummaryHint': 'Sales, collection and current receivables',
  'dashboard.recentSales': 'Recent sales',
  'dashboard.noRecentSales': 'No sales have been recorded yet.',
  'dashboard.viewAll': 'View all',
  'dashboard.openReports': 'Open reports',
  'dashboard.reportsTitle': 'Reports',
  'dashboard.reportsHint': 'Review sales, collection, expenses and stock movement by period.',
  'dashboard.overviewHint': 'A quick start for your daily work.',
  'dashboard.userFallback': 'User',
  'dashboard.welcomeBack': 'Welcome back, {0}!',
  'dashboard.roleLabel': 'Role:',
  'dashboard.companies': 'Companies',
  'dashboard.users': 'Users',
  'dashboard.customers': 'Customers',
  'dashboard.items': 'Items',
  'dashboard.businessOverview': 'Business overview',
  'dashboard.businessOverviewHint': 'See sales, collections and stock status at a glance.',
  'dashboard.period': 'Period',
  'dashboard.thisMonth': 'This month',
  'dashboard.last30Days': 'Last 30 days',
  'dashboard.thisYear': 'This year',
  'dashboard.refresh': 'Refresh',
  'dashboard.superAdminTitle': 'Superadmin overview',
  'dashboard.superAdminHint': 'Monitor company status and usage from one place.',
  'dashboard.totalCompanies': 'Total companies',
  'dashboard.activeUsageCompanies': 'Used in the last 30 days',
  'dashboard.activeSubscriptionCompanies': 'Active subscription',
  'dashboard.newCompanies': 'New this period',
  'dashboard.expiringCompanies': 'Expiring within 7 days',
  'dashboard.restrictedCompanies': 'Restricted access',
  'dashboard.companyManagement': 'Company management',
  'dashboard.companyManagementHint': 'Open company details, users, subscriptions, and notes.',
  'dashboard.viewCompanies': 'View companies',
  'dashboard.attentionTitle': 'Companies needing attention',
  'dashboard.attentionHint': 'These lists use the same filters and ordering as the company management view.',
  'dashboard.attentionExpiring': 'Expiring soon',
  'dashboard.attentionRestricted': 'Restricted',
  'dashboard.attentionInactive': 'Inactive for 30 days',
  'dashboard.attentionNeverUsed': 'Never used',
  'dashboard.attentionEmpty': 'No companies match this list.',
  'dashboard.attentionLoadError': 'Attention lists could not be loaded.',
  'dashboard.attentionOpen': 'Open details',
  'dashboard.attentionEndsAt': 'Ends',
  'dashboard.attentionLastActivity': 'Last activity',
  'dashboard.totalSales': 'Total sales',
  'dashboard.totalCollection': 'Total collection',
  'dashboard.totalReceivables': 'Current receivables',
  'dashboard.salesCount': '{0} sales records',
  'dashboard.periodCollectionHint': 'Collected in the selected period',
  'dashboard.receivablesHint': 'Balance at {0} customers · {1} open sales',
  'dashboard.stockSalesValue': 'Stock sales value',
  'dashboard.stockSalesValueHint': 'Current stock quantity × current sale price. Not cost or profit.',
  'dashboard.salesAndCollection': 'Sales and collection',
  'dashboard.salesAndCollectionHint': 'Movement in the selected period',
  'dashboard.sales': 'Sales',
  'dashboard.collection': 'Collection',
  'dashboard.expenses': 'Expenses',
  'dashboard.topDebtors': 'Highest balances',
  'dashboard.topSellingItems': 'Best-selling items',
  'dashboard.topDebtorsHint': 'Based on current remaining balance',
  'dashboard.topSellingItemsHint': 'Based on the selected period',
  'dashboard.noTopDebtors': 'There are no customers with an open balance.',
  'dashboard.noTopSellingItems': 'There are no item sales in the selected period.',
  'dashboard.quantity': 'units',
  'dashboard.attention': 'Needs attention',
  'dashboard.outOfStockProducts': 'Out-of-stock products',
  'dashboard.outOfStockProductsDetail': '{0} products have no stock left.',
  'dashboard.unpaidExpenses': 'Unpaid expenses',
  'dashboard.unpaidExpensesDetail': '{0} of unpaid expenses in the selected period.',
  'dashboard.expiringBatches': 'Expiring/expired batches',
  'dashboard.expiringBatchesDetail': '{0} batches have expiration information.',
  'dashboard.overdueInstallments': 'Overdue installments',
  'dashboard.overdueInstallmentsDetail': '{0} customers have {1} overdue installments · {2} total',
  'dashboard.dueSoonInstallments': 'Installments due soon',
  'dashboard.dueSoonInstallmentsDetail': '{1} installments for {0} customers are due within 5 days · {2} total',
  'dashboard.noAlerts': 'Nothing needs attention right now.',
  'dashboard.detailLinksTitle': 'Continue to details',
  'dashboard.batchExpiryHint': 'Expiration information is shown only for batch-tracked items.',
  'dashboard.openReceivables': 'Customer accounts',
  'dashboard.openStock': 'Stock view',
  'dashboard.emptyState': 'There is no sales or item data to show yet.',
  
  // Filters
  'filters.title': 'Filters',
  'filters.clear': 'Clear Filters',
  'filters.apply': 'Apply Filters',
  'filters.createdBy': 'Created By',
  'filters.dateRange': 'Date Range',
  'filters.startDate': 'Start Date',
  'filters.endDate': 'End Date',
  'filters.amountRange': 'Amount Range',
  'filters.minAmount': 'Min Amount',
  'filters.maxAmount': 'Max Amount',
  'filters.allUsers': 'All Users',
  'filters.company': 'Company',
  'filters.allCompanies': 'All Companies',
  'filters.showFilters': 'Show Filters',
  'filters.hideFilters': 'Hide Filters',
  
  // DataGrid
  'dataGrid.noRowsLabel': 'No rows',
  'dataGrid.noResultsOverlayLabel': 'No results found.',
  'dataGrid.errorOverlayDefaultLabel': 'An error occurred.',
  'dataGrid.toolbarDensity': 'Density',
  'dataGrid.toolbarDensityLabel': 'Density',
  'dataGrid.toolbarDensityCompact': 'Compact',
  'dataGrid.toolbarDensityStandard': 'Standard',
  'dataGrid.toolbarDensityComfortable': 'Comfortable',
  'dataGrid.toolbarColumns': 'Columns',
  'dataGrid.toolbarColumnsLabel': 'Select columns',
  'dataGrid.toolbarFilters': 'Filters',
  'dataGrid.toolbarFiltersLabel': 'Show filters',
  'dataGrid.toolbarFiltersTooltipHide': 'Hide filters',
  'dataGrid.toolbarFiltersTooltipShow': 'Show filters',
  'dataGrid.toolbarFiltersTooltipActive': 'filters active',
  'dataGrid.toolbarExport': 'Export',
  'dataGrid.toolbarExportLabel': 'Export',
  'dataGrid.toolbarExportCSV': 'Download as CSV',
  'dataGrid.toolbarExportPrint': 'Print',
  'dataGrid.columnMenuLabel': 'Menu',
  'dataGrid.columnMenuShowColumns': 'Show columns',
  'dataGrid.columnMenuFilter': 'Filter',
  'dataGrid.columnMenuHideColumn': 'Hide',
  'dataGrid.columnMenuUnsort': 'Unsort',
  'dataGrid.columnMenuSortAsc': 'Sort by ASC',
  'dataGrid.columnMenuSortDesc': 'Sort by DESC',
  'dataGrid.columnHeaderFiltersTooltipActive': 'filters active',
  'dataGrid.columnHeaderFiltersLabel': 'Show filters',
  'dataGrid.columnHeaderSortIconLabel': 'Sort',
  'dataGrid.footerRowSelected': 'rows selected',
  'dataGrid.footerTotalRows': 'Total Rows:',
  'dataGrid.footerTotalVisibleRows': 'of visible rows:',
  'dataGrid.checkboxSelectionHeaderName': 'Checkbox selection',
  'dataGrid.booleanCellTrueLabel': 'yes',
  'dataGrid.booleanCellFalseLabel': 'no',
  'dataGrid.actionsCellMore': 'more',
  'dataGrid.filterPanelAddFilter': 'Add filter',
  'dataGrid.filterPanelDeleteIconLabel': 'Delete',
  'dataGrid.filterPanelLinkOperator': 'Logic operator',
  'dataGrid.filterPanelOperators': 'Operators',
  'dataGrid.filterPanelOperatorAnd': 'And',
  'dataGrid.filterPanelOperatorOr': 'Or',
  'dataGrid.filterPanelColumns': 'Columns',
  'dataGrid.filterPanelInputLabel': 'Value',
  'dataGrid.filterPanelInputPlaceholder': 'Filter value',
  'dataGrid.filterOperatorContains': 'contains',
  'dataGrid.filterOperatorEquals': 'equals',
  'dataGrid.filterOperatorStartsWith': 'starts with',
  'dataGrid.filterOperatorEndsWith': 'ends with',
  'dataGrid.filterOperatorIs': 'is',
  'dataGrid.filterOperatorNot': 'is not',
  'dataGrid.filterOperatorAfter': 'is after',
  'dataGrid.filterOperatorOnOrAfter': 'is on or after',
  'dataGrid.filterOperatorBefore': 'is before',
  'dataGrid.filterOperatorOnOrBefore': 'is on or before',
  'dataGrid.filterOperatorIsEmpty': 'is empty',
  'dataGrid.filterOperatorIsNotEmpty': 'is not empty',
  'dataGrid.filterOperatorIsAnyOf': 'is any of',

  // Categories
  'category.title': 'Categories',
  'category.created': 'Category created.',
  'category.updated': 'Category updated.',
  'category.deleted': 'Category deleted.',
  'category.managementHint': 'Organize products with categories.',
  'category.actions': 'Category actions',
  'category.add': 'Add Category',
  'category.edit': 'Edit Category',
  'category.create': 'Create Category',
  'category.delete': 'Delete Category',
  'category.manage': 'Manage Categories',
  'category.name': 'Category Name',
  'category.description': 'Description',
  'category.color': 'Color',
  'category.noDescription': 'No description',
  'category.noCategories': 'No categories found. Create your first category to get started.',
  'category.nameRequired': 'Category name is required',
  'category.colorInvalid': 'Color must be a valid hex color code',
  'category.failedToSave': 'Failed to save category. Please try again.',
  'category.deleteConfirmation': 'Are you sure you want to delete the category "{name}"? This action cannot be undone.',
  'category.addNewCategory': 'Add New Category',

  // Column Configuration
  'columns.title': 'Columns',
  'columns.configuration': 'Column Configuration',
  'columns.manage': 'Manage Columns',
  'columns.show': 'Show Columns',
  'columns.hide': 'Hide Columns',

  // Filter
  'filter.categories': 'Categories in filter',
  'filter.selectCategories': 'Select categories to filter',

  // Loading
  'loading.failedToLoad': 'Failed to load',

  // Brand page
  'brand.pageTitle': 'Brand identity',
  'brand.eyebrow': 'THE VERESIYE IDENTITY',
  'brand.headline': 'Accurate records. Clear decisions.',
  'brand.description': 'Veresiye organizes customer, inventory, sales, and open-account activity into clear, traceable electronic records.',
  'brand.electronicBadge': 'ELECTRONIC CREDIT RECORDS',
  'brand.lockupDescription': 'The gold e highlights electronic record keeping. Clean lines reflect an orderly, easy-to-read system.',
  'brand.symbolTitle': 'The shopkeeper',
  'brand.symbolDescription': 'The shopkeeper represents the person using the system each day. The open form and V-shaped fold suggest clear, orderly records.',
  'brand.paletteTitle': 'Brand colors',
  'brand.pine': 'Pine green',
  'brand.brass': 'Accent gold',
  'brand.paper': 'Soft cream',
};
